import {connect} from 'react-redux'
import {ActionsRow, commons, field, FixedDropDownButton, Icon, Loader, modal, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Alert, Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as subjektActions from "../../actions/subjektActions";
import {SPOLECNOSTI_FETCH_LIMIT} from "../../actions/subjektActions";
import TablePanel from "../../components/TablePanel";
import SpolecnostForm from "../../forms/SpolecnostForm";
import SubjektApi from "../../api/gen/cgo/SubjektApi";
import {withRouter} from "react-router";
import NastaveniObjednavkySpolecnostForm from "../../forms/NastaveniObjednavkySpolecnostForm";
import {ADMIN_BASE_PATH, SPOLECNOSTI_PATH} from "../../const/routes";
import * as opravneniActions from "../../actions/opravneniActions";
import * as EnumRole from "../../api/gen/cgo/EnumRole";
import CustomCheckbox from "../../components/CustomCheckbox";
import {withTranslation, WithTranslation} from "react-i18next";

const {sinkEvent} = commons;

/**
 * Stránka administrace - Společnosti
 */
class SpolecnostiPage extends Component<WithTranslation> {

    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(subjektActions.fetchSpolecnostiIfNeeded());
    };

    handleCreateSpolecnost = () => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            SpolecnostForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.createSpolecnost(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateSpolecnosti());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('new_company'),
            {size: "md"}
        ));
    };

    handleEditSpolecnost = (spolecnost) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            SpolecnostForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.updateSpolecnost(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateSpolecnosti());
                    dispatch(subjektActions.invalidateSpolecnostDetail(spolecnost.id));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: spolecnost
            },
            t('company_change'),
            {size: "md"}
        ));
    };

    handleEditNastaveniObjednavky = (spolecnost) => {
        const {t} = this.props;
        const {zpusobDopravaVychozi, zpusobPlatbaVychozi, pobockaVydej, preskocitKontakt, preskocitDoprava, preskocitPlatba, povinneNaklStredisko, naklStrediskoTextem} = spolecnost;
        this.props.dispatch(modal.ModalActions.show(
            NastaveniObjednavkySpolecnostForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.updateSpolecnostPredvolby(data, spolecnost.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateSpolecnosti());
                    dispatch(subjektActions.invalidateSpolecnostDetail(spolecnost.id));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                        zpusobDopravaVychozi,
                        zpusobPlatbaVychozi,
                        pobockaVydej,
                        preskocitKontakt,
                        preskocitDoprava,
                        preskocitPlatba,
                        povinneNaklStredisko,
                        naklStrediskoTextem
                },
                spolecnostId: spolecnost.id
            },
            t('company_change'),
            {size: "md"}
        ));
    };

    handleShowSpolecnost = (spolecnost) => {
        this.props.history.push(`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/${spolecnost.id}`);
    };

    handleFulltextChange = (value) => {
        const {spolecnostiList} = this.props;
        this.props.dispatch(subjektActions.filterSpolecnosti({
            ...spolecnostiList.filter,
            fulltext: value
        }, false));
    };

    handleVcetneNeaktivnich = (e) => {
        const {spolecnostiList} = this.props;
        this.props.dispatch(subjektActions.filterSpolecnosti({
            ...spolecnostiList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    handleClearFulltext = () => {
        this.handleFulltextChange("");
    };

    fetchSpolecnostRights = (spolecnostId) => {
        if (!this.state[spolecnostId]) {
            SubjektApi.getSpolecnostRights(spolecnostId).then(rights => {
                this.setState({[spolecnostId]: rights});
            });
        }
    };

    renderContextMenu = (spolecnost) => {
        const {t} = this.props;
        const rights = this.state[spolecnost.id];
        const canUpravitUdaje = rights && rights.spolecnostEdit;
        return <FixedDropDownButton onToggle={this.fetchSpolecnostRights.bind(this, spolecnost.id)} color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleShowSpolecnost.bind(this, spolecnost))}>{t('show_detail')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleEditSpolecnost.bind(this, spolecnost))} disabled={!canUpravitUdaje}>{t('edit_details')}</DropdownItem>
            <DropdownItem key="2" onClick={sinkEvent(this.handleEditNastaveniObjednavky.bind(this, spolecnost))}>{t('order.edit_configuration')}</DropdownItem>
        </FixedDropDownButton>
    };

    render() {
        const {spolecnostiList, loggedInUser, t} = this.props;
        let content;
        if (spolecnostiList.fetched) {
            if (spolecnostiList.rows.length !== 0) {
                content = spolecnostiList.rows.map((spolecnost) => {
                    return <CardBody key={spolecnost.id}>
                        <ActionsRow actions={this.renderContextMenu(spolecnost)} onClick={this.handleShowSpolecnost.bind(this, spolecnost)}>
                            <Row>
                                <Col className="overflow">{spolecnost.nazevSpolecnost}</Col>
                                <Col className="overflow">{spolecnost.ic}</Col>
                                <Col className="overflow">{spolecnost.dic}</Col>
                                <Col className="overflow">{spolecnost.email}</Col>
                                <Col className="overflow">{spolecnost.telefon}</Col>
                                <Col className="overflow">{spolecnost.povinneNaklStredisko ? t('yes') : t('no')}</Col>
                                <Col className="overflow">{spolecnost.naklStrediskoTextem ? t('yes') : t('no')}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('no_companies')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }

        const extRezim = loggedInUser.data.extSystemRezim;
        const role = loggedInUser.data.role;
        const vcetneNeaktivnich = spolecnostiList.filter.vcetneNeaktivnich || false;

        return <AdminPage
            title={t('companies')}
            subtitle={t('companies')}
            content={
                <div>
                    <Row>
                        <Col xs={9}>
                            <ButtonToolbar>
                                {role === EnumRole.ADMIN && !extRezim && <Button color="primary" onClick={this.handleCreateSpolecnost}>{t('new_f')}</Button>}
                                <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                            </ButtonToolbar>
                        </Col>
                        <Col xs={3}>
                            <field.Search value={spolecnostiList.filter.fulltext} onChange={this.handleFulltextChange} placeholder={t('filter_company')} />
                        </Col>
                    </Row>
                    {spolecnostiList.filter.fulltext &&
                    <Alert color="info" isOpen toggle={this.handleClearFulltext}>Výsledky hledání výrazu
                        "{spolecnostiList.filter.fulltext}".</Alert>}
                    {spolecnostiList.rows.length >= SPOLECNOSTI_FETCH_LIMIT &&
                    <Alert color="info">Zobrazuje se prvních {SPOLECNOSTI_FETCH_LIMIT} nalezených společností. Pro filtrování použijte vyhledávač.</Alert>}
                    <TablePanel header={
                        <Row>
                            <Col>{t('labels.name')}</Col>
                            <Col>{t('cin')}</Col>
                            <Col>{t('vatin')}</Col>
                            <Col>{t('email')}</Col>
                            <Col>{t('phone')}</Col>
                            <Col>{t('order.name_required')}</Col>
                            <Col>{t('order.name_text')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        spolecnostiList: utils.storeFromArea(state, subjektActions.SPOLECNOSTI_LIST_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(SpolecnostiPage)));

